import { render } from "./PackageVolumeTypeCatalogue.vue?vue&type=template&id=a95705da&ts=true"
import script from "./PackageVolumeTypeCatalogue.vue?vue&type=script&lang=ts"
export * from "./PackageVolumeTypeCatalogue.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__